import React from 'react'
import loadable from '@loadable/component'
import classnames from 'classnames'

import { get, size } from 'lodash'
import { connect, useDispatch } from 'react-redux'
import { showModal } from '@krea/common/store/modal/actions'

import { useTranslation } from 'react-i18next'

import { useMobile } from '@krea/common/hooks'
import { Text, Button } from '@krea/common/shared-components'
import { MenuContext } from './../header'
import ChangeApplicationModal from 'krea-direct/components/modals/ChangeApplicationModal'

const AppTooltip = loadable(() => import('@krea/common/shared-components').then((mod) => mod.AppTooltip))

const ApplicationSelector = ({ currentLoanApplication, activeLoanApplicationsCount }) => {
	const { t } = useTranslation()
	const isMobile = useMobile()

	const dispatch = useDispatch()

	const onChangeApplication = () => {
		dispatch(showModal(<ChangeApplicationModal />))
	}

	const buttonText = t('applicationSummary.change')

	const application = currentLoanApplication
	let companyName = null
	const company =
		application && application.applyingCompany && application.applyingCompany.customerCompany
			? application.applyingCompany.customerCompany
			: null

	if (company) {
		companyName = company.name
	}

	return (
		<>
			{!isMobile ? (
				<div className={classnames('d-flex ml-4')}>
					{companyName && (
						<div
							className={classnames('d-flex align-items-center', {
								'pr-3': activeLoanApplicationsCount > 1
							})}
							style={{ maxWidth: '10rem' }}
						>
							<AppTooltip content={companyName} className="w-100">
								<Text size="sm" className="w-100 font-weight-bold text-truncate text-secondary">
									{companyName}
								</Text>
							</AppTooltip>
						</div>
					)}

					{activeLoanApplicationsCount > 1 && (
						<MenuContext.Consumer>
							{({ toggleMenu }) => (
								<Button
									variant="outlined"
									className="flex-shrink-0"
									onClick={() => {
										onChangeApplication()
										toggleMenu()
									}}
								>
									{buttonText}
								</Button>
							)}
						</MenuContext.Consumer>
					)}
				</div>
			) : (
				<div className="w-100 flex-md-grow-1" style={{ minWidth: '0px' }}>
					<div className="d-flex flex-column flex-md-row align-items-center rounded bg-gray pb-4 p-md-0">
						<div
							className="pb-5 pb-md-0 pr-md-4 text-center text-md-left w-100 flex-grow-1"
							style={{ minWidth: '0px' }}
						>
							{companyName && (
								<>
									<Text size="sm" className="font-weight-bold text-gray-dark">
										{t('applicationSummary.companyNameLabel')}
									</Text>
									<Text className="font-weight-bold text-truncate">{companyName}</Text>
								</>
							)}
						</div>

						{activeLoanApplicationsCount > 1 && (
							<div className="flex-shrink-0">
								<MenuContext.Consumer>
									{({ toggleMenu }) => (
										<Button
											variant="text"
											className="px-4"
											onClick={() => {
												onChangeApplication()
												toggleMenu()
											}}
										>
											{buttonText}
										</Button>
									)}
								</MenuContext.Consumer>
							</div>
						)}
					</div>
				</div>
			)}
		</>
	)
}

const mapStateToProps = (state) => ({
	currentLoanApplication: get(state.currentLoanApplicationReducer, 'currentLoanApplication'),
	activeLoanApplicationsCount: size(get(state.loanApplicationsReducer, 'loanApplications', []))
})

export default connect(mapStateToProps)(ApplicationSelector)
